export const MULTIHUB_WEB_USER="MULTIHUB_WEB_USER"


export const getUser=()=> JSON.parse(window.localStorage.getItem(MULTIHUB_WEB_USER))

export const setUser=(user_data)=> window.localStorage.setItem(MULTIHUB_WEB_USER,JSON.stringify(user_data))    

export const removeUser=()=> window.localStorage.removeItem(MULTIHUB_WEB_USER)

